import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';

interface IProps {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  isOpen: boolean;
}

export const QuitAnnotationsModal = observer((props: IProps): ReactElement => {
  return (
    <ConfirmationModal
      showModal={props.isOpen}
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      confirmationHeader='warning'
      confirmationQuestion='are_you_sure_you_want_to_quit'
      confirmationYes={'quit'}
    />
  );
});
